"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require("react"),
    useState = _require.useState,
    useEffect = _require.useEffect;

function getOnlineStatus() {
  return typeof navigator !== "undefined" && typeof navigator.onLine === "boolean" ? navigator.onLine : true;
}

function useOnlineStatus() {
  var _useState = useState(getOnlineStatus()),
      _useState2 = _slicedToArray(_useState, 2),
      onlineStatus = _useState2[0],
      setOnlineStatus = _useState2[1];

  var goOnline = function goOnline() {
    return setOnlineStatus(true);
  };

  var goOffline = function goOffline() {
    return setOnlineStatus(false);
  };

  useEffect(function () {
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return function () {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);
  return onlineStatus;
}

module.exports = useOnlineStatus;